import { gql } from 'glimmer-apollo';

export const GAMES_LIST_QUERY = gql`
  query GamesList {
    games {
      id
      name
      title
      slug
      description
      subTitle
      image {
        url
      }
      releaseDate
      price
    }
  }
`;
